import { ValidationUtil } from 'rmesse-utils';

export class RmesseValidationWrapper {
  private static ERR_MSG_ATTACHMENT_TYPE_DENIED =
    'アップロードできないファイル形式です。'; // this "inconsistent" error message is intentional to find this Wrapper by the error message.

  public static validateAttachFile(file: File): string[] {
    // tiff / tiff file is not supported, though Ichiba RMesse allows (but the error message does not!).
    // this is why the file type is not popular in actual use in Ichiba, and it is hard to show in thumbnail with data URL.
    // further, Travel APP (showing RMP in Webview, in iOS) does not support the file type.
    if (
      file.name.toLowerCase().endsWith('tiff') ||
      file.name.toLowerCase().endsWith('tif')
    ) {
      return [this.ERR_MSG_ATTACHMENT_TYPE_DENIED];
    }
    const currentAttachmentValidationErrors = ValidationUtil.validateAttachFile(
      file.name,
      file.type,
      file.size,
    );
    if (currentAttachmentValidationErrors) {
      return currentAttachmentValidationErrors;
    }
    return [];
  }
}
